//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FlexButtonGroup from '../flex/FlexButtonGroup';
import SpriteIcon from "../elements/SpriteIcon";
import { slideDown, slideUp } from '../../helpers/slide';
import FlexSelect from "../flex/FlexSelect";

export default {
    components: {
        FlexSelect,
        FlexButtonGroup,
        SpriteIcon,
    },
    props: {
        lang: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            typeOfCustomerChoice: {
                'b2c': this.$options.filters.__('user.b2c'),
                'b2b': this.$options.filters.__('user.b2b'),
            },
            genderChoice: {
                'male': this.$options.filters.__('user.man'),
                'female': this.$options.filters.__('user.woman'),
            },
            customerType: 'b2b',
            customer: {
                type: 'b2b',
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                gender: 'male',
                company: '',
                vat: '',
                deliveryStreet: '',
                deliveryStreetNumber: '',
                deliveryBox: '',
                deliveryZipCode: '',
                deliveryCity: '',
                deliveryCountry: 'BE',
                billingStreet: '',
                billingStreetNumber: '',
                billingBox: '',
                billingZipCode: '',
                billingCity: '',
                billingCountryCode: 'BE',
                sameAddress: true,
            },
            errors: {},
            errorVat: false,
        }
    },
    computed: {
        computedCountry: function() {
            return this.lang === 'nl' ? 'België' : 'Belgique';
        }
    },
    methods: {
        handlePrevious(step = -1)
        {
            window.dataLayer?.push( { 'event': 'step2prev' } );

            this.$nextTick( () => this.$emit('previous', step ) );
        },

        handleSubmit()
        {
            const customer = this.customer;

            if ( this.customer.type === 'b2b' ) {
                if ( this.customer.vat === null || this.customer.vat.match(/BE[0-9]{10,}/) === null ) {
                    this.errorVat = true;

                    return;
                }
            }

            this.$app.get('axios').post('/api/funnel/user?lang=' + this.lang, customer ).then( response => {
                if ( response.data.user ) {
                    this.customer = response.data.user;

                    this.$refs.b2b_inputs.style.display = this.customer.type === 'b2c' ? 'none' : 'block';
                    this.$refs.billing_form.style.display = this.customer.sameAddress ? 'none' : 'block';

                    window.dataLayer?.push( { 'event': 'step2next' } );

                    this.$nextTick( () => this.$emit('submit') )
                } else {
                    this.errors = response.data.errors;

                    this.$el.parentElement.scrollIntoView({ behavior: 'smooth' })

                    this.$forceUpdate();
                }
            } );
        },

        handleCustomerButton(value)
        {
            const inputs = this.$refs.b2b_inputs;

            if ( value === this.customerType ) {
                return;
            }

            if ( value === 'b2b' ) {
                slideDown( inputs, 300 );
            } else {
                slideUp( inputs, 300 );
            }

            this.customerType = value;
        },

        handleBillingAddress($event)
        {
            const form = this.$refs.billing_form;

            if ( $event.target.checked ) {
                slideUp( form, 300 );
            } else {
                slideDown( form, 300 );
            }
        },
    },

    created() {
        this.$app.get('axios').get('/api/funnel/user?lang=' + this.lang ).then( response => {
            if ( response.data === false ) {
                this.handlePrevious( 0 );
            }

            this.customer = response.data;

            this.customerType = this.customer.type;

            this.$refs.b2b_inputs.style.display = this.customer.type === 'b2c' ? 'none' : 'block';
            this.$refs.billing_form.style.display = this.customer.sameAddress ? 'none' : 'block';
        } );
    },

    mounted() {
        window.dataLayer?.push( { 'event': 'step2in' } );
    }
}
